import {
  Autocomplete, Box, IconButton, Table, TableBody, TableCell, TableHead,
  TableRow, TextField, Typography, Accordion, AccordionSummary, AccordionDetails, 
  Tooltip
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { useDebounce } from '../../../../Components/Common Components/CommonComponents'
import { COMMON_STYLE } from '../../../../Utility/Constants'
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HistoryIcon from '@mui/icons-material/History';
import PreviousDiagnosis from '../../DoctorNotes/Common/PreviousDiagnosis'

const diagnosisState = {
  patientId: '',
  clinicId: '',
  appointmentId: '',
  doctorId: '',
  provisionalDiagnosis: '',
  diagnosisData: [],
  provisionalDiagnosisSugg: [],
  diagnosisSugg: [],
  dupDiagnosisData: '[]',
  dupProvisionalDiagnosis: '',
  accordionOpen: false,
  PreviousDiagnosisPopup: false,
  dateList: [],
  previousData: [],
  is_previous_loading: false,
}

const UmaDiagnosis = React.forwardRef((props, ref) => {
  const [diagnosis, setDiagnosis] = useState(diagnosisState)
  const [search, setSearch] = useState('')
  const [searchIcd, setSearchIcd] = useState('')
  const [key, setKey] = useState('')
  const debouneQuery = useDebounce(search, 500)
  const icdQuery = useDebounce(searchIcd, 500)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - DIAGNOSIS`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - DIAGNOSIS`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performDiagnosisAction: () => {
      if (
        (JSON.stringify(diagnosis.provisionalDiagnosis) !== diagnosis.dupProvisionalDiagnosis) ||
        (JSON.stringify(diagnosis.diagnosisData) !== diagnosis.dupDiagnosisData)
      ) {
        postDiagonisData()
      }
    }
  }))

  const apicalls = async () => {
    await getDiagonisData()
    await getPreviousDiagnosis();
  }

  useEffect(() => {
    if (debouneQuery) {
      getProvisionalDiaSuggData(debouneQuery)
    } else {
      setDiagnosis((prev) => ({ ...prev, provisionalDiagnosisSugg: [] }))
    }

    if (key && icdQuery) {
      switch (key) {
        case 'icd_code':
          return getDiagnosisSuggData('icd_code', icdQuery)
        case 'short_desc':
          return getDiagnosisSuggData('desc', icdQuery)
        case 'desc':
          return getDiagnosisSuggData('long_desc', icdQuery)
      }
    } else {
      setDiagnosis((prev) => ({ ...prev, diagnosisSugg: [], key: '' }))
    }
  }, [debouneQuery, icdQuery, key])

  const getDiagonisData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_DIAGNOSIS + '?appointment_id=' + props?.props?.appointment_id)
      if (response?.data?.status === 'success') {
        let diaData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        let diaArray = { "icd_code": '', "short_desc": '', "desc": '' }
        setDiagnosis((prev) => ({
          ...prev,
          diagnosisData: Object.keys(diaData)?.length > 0 ? [...diaData?.icd_code, diaArray] : [diaArray],
          provisionalDiagnosis: Object.keys(diaData)?.length > 0 ? diaData?.provisional_diagnosis : '',
          dupDiagnosisData: Object.keys(diaData)?.length > 0 ? JSON.stringify([...diaData?.icd_code, diaArray]) : JSON.stringify([diaArray]),
          dupProvisionalDiagnosis: Object.keys(diaData)?.length > 0 ? JSON.stringify(diaData?.provisional_diagnosis) : JSON.stringify(''),
          accordionOpen: (diaData?.icd_code?.length > 0 || diaData?.provisional_diagnosis?.length > 0) ? true : false 
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPreviousDiagnosis = async (date = "") => {
    try {
      const url = `${Serviceurls.UMA_DOC_PREVIOUS_DIAGNOSIS_GET}?patient_id=${props?.props?.patient_id}&appointment_id=${props?.props?.appointment_id}`
      setDiagnosis((prev) => ({
        ...prev,
        previousData: [],
        is_previous_loading: false,
      }))
      const response = await RestAPIService.getAll(url + (date ? `&date=${date}` : ""))
      if (response?.data?.status === 'success') {
        const responseData = response?.data?.data || [];
        const dates = response?.data?.dates || diagnosis.dateList;

        // Process the data
        const processedData = responseData?.map((item) => ({
          appointment_id: item.appointment_id,
          icd_code: item.icd_code,
          diagnosis: item.provisional_diagnosis
        }))

        setDiagnosis((prev) => ({
          ...prev,
          dateList: dates,
          previousData: processedData || [],
          is_previous_loading: false,
        }))
      }
    } catch (error) {
      setDiagnosis((prev) => ({
        ...prev,
        is_previous_loading: false,
      }))
      errorMessage(error?.response?.data?.message || error?.message)
    }
  }

  const closePreviousPopup = () => {
    setDiagnosis((prev) => ({
      ...prev,
      PreviousDiagnosisPopup: false
    }))
  }

  const getDiagnosisSuggData = async (searchBy, searchKey) => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_DIAGNOSIS_SEARCH + `?${searchBy}=${searchKey}`)

      if (response?.data?.status === 'success') {
        setDiagnosis((prev) => ({
          ...prev,
          diagnosisSugg: response?.data?.data
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getProvisionalDiaSuggData = async (search) => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_DIAGNOSIS_PROV_SUGG + '?provisional_diagnosis=' + search)

      if (response?.data?.status === 'success') {
        setDiagnosis((prev) => ({
          ...prev,
          provisionalDiagnosisSugg: response?.data?.data
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postDiagonisData = async (copyData = {}) => {
    try {
      let filteredArray = diagnosis.diagnosisData?.filter(item => (item?.icd_code !== ''))
      let data = {
        appointment_id: props?.props?.appointment_id,
        provisional_diagnosis: diagnosis.provisionalDiagnosis,
        icd_code: filteredArray
      }
      const isCopyData = copyData && Object.keys(copyData)?.length > 0
      const response = await RestAPIService.create(isCopyData ? copyData : data, Serviceurls.NEW_DOC_NOTES_DIAGNOSIS)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        if(isCopyData){
            closePreviousPopup()
        }
        await getDiagonisData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const handleDiagnosisCopy = (from = "both", passedData) => {
    let data = {
      appointment_id: props?.props?.appointment_id,
      patient_id: props?.props?.patient_id,
    }
    switch (from) {
      case "IcdCode":
        data["icd_code"] = passedData?.length > 0 ? passedData?.map(({id, ...item}) => item) : [];
        break;
      case "diagnosis":
        data["provisional_diagnosis"] = passedData || ""
        break;
      default:
        data["icd_code"] = passedData?.icd_code?.length > 0 ? passedData?.icd_code?.map(({id, ...item}) => item) : [];
        data["provisional_diagnosis"] = passedData?.diagnosis || "";
        break;
    }
    postDiagonisData(data);
  }

  const deleteDiagonisData = async (item, index) => {
    try {
      if (item?.id) {
        let data = { id: item?.id }
        const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_DIAGNOSIS, data)
        if (response?.data?.status === 'success') {
          successMessage(response?.data?.message)
          await getDiagonisData()
        }
      } else {
        let diagnosisData = [...diagnosis.diagnosisData]
        setDiagnosis((prev) => {
          if (index !== (diagnosis.diagnosisData?.length - 1)) {
            diagnosisData?.splice(index, 1)
          } else {
            diagnosisData[index] = { icd_code: '', short_desc: '', desc: '', }
          }
          return { ...prev, diagnosisData }
        })
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const onChangeHandler = (newValue, key, index) => {
    try {
      setDiagnosis((prev) => {
        const diagnosisData = [...prev.diagnosisData]
        switch (key) {
          case 'icd_code':
            diagnosisData[index] = {
              ...diagnosisData[index],
              icd_code: newValue?.icd_code,
              short_desc: newValue?.icd_short_desc,
              desc: newValue?.icd_desc
            };
            if (newValue !== '' && index === diagnosisData.length - 1) {
              let obj = { "icd_code": "", "short_desc": '', "desc": '' }
              diagnosisData?.push(obj)
            }
            break;
          case 'short_desc':
            diagnosisData[index] = {
              ...diagnosisData[index],
              icd_code: newValue?.icd_code,
              short_desc: newValue?.icd_short_desc,
              desc: newValue?.icd_desc
            };
            if (newValue !== '' && index === diagnosisData.length - 1) {
              let obj = { "icd_code": "", "short_desc": '', "desc": '' }
              diagnosisData?.push(obj)
            }
            break;
          case 'desc':
            diagnosisData[index] = {
              ...diagnosisData[index],
              icd_code: newValue?.icd_code,
              short_desc: newValue?.icd_short_desc,
              desc: newValue?.icd_desc
            };
            if (newValue !== '' && index === diagnosisData.length - 1) {
              let obj = { "icd_code": "", "short_desc": '', "desc": '' }
              diagnosisData?.push(obj)
            }
            break;
        }
        return { ...prev, diagnosisData, diagnosisSugg: [], provisionalDiagnosisSugg: [] }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const autocompleteTextbox = (names, values, options = [], label, placeholders, index) => {
    try {
      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          clearIcon
          size='small'
          sx={{ width: '20dvw' }}
          value={values}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[label]}
          onChange={(e, newValue) => {
            onChangeHandler(newValue, names, index)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholders}
              InputProps={{
                ...params.InputProps, emed_id: names,
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
              onChange={(e) => {
                let value = e.target.value
                setSearchIcd(value)
                setKey(names)
              }}
            />
          )}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={diagnosis.accordionOpen}
          onChange={(_, isExpanded) => {
            setDiagnosis((prev) => ({ ...prev, accordionOpen: isExpanded }))
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
            <Typography className='doc_notes_header_card_font'>Diagnosis</Typography>
            <Tooltip placement='top' title='Previous Diagnosis' arrow>
              <IconButton
                disabled={props?.props?.isLocked || props?.props?.patient_transfered}
                onClick={(e) => {
                  e.stopPropagation();
                  setDiagnosis((prev) => ({ ...prev, PreviousDiagnosisPopup: true }))
                }}
              ><HistoryIcon color={props?.props?.isLocked || props?.props?.patient_transfered ? '' : 'primary'} /></IconButton>
            </Tooltip>
            </Box>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>ICD Code</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Short Description</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Long Description</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {diagnosis?.diagnosisData?.length > 0 ? diagnosis.diagnosisData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          {autocompleteTextbox('icd_code', item?.icd_code, diagnosis.diagnosisSugg, 'icd_code', 'Search ICD Code', index)}
                        </TableCell>
                        <TableCell>
                          {autocompleteTextbox('short_desc', item?.short_desc, diagnosis.diagnosisSugg, 'icd_short_desc', 'Search Short Description', index)}
                        </TableCell>
                        <TableCell>
                          {autocompleteTextbox('desc', item?.desc, diagnosis.diagnosisSugg, 'icd_desc', 'Search Long Description', index)}
                        </TableCell>
                        <TableCell>
                          <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_id='comp_dlt'
                            disabled={props?.props?.patient_transfered}
                            onClick={() => { deleteDiagonisData(item, index) }}
                          ><DeleteIcon color='error' /></IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  }) : <TableRow><TableCell colSpan={4} align='center'>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                </TableBody>
              </Table>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <Typography className='doc_notes_header_card_font'>Provisional Diagnosis</Typography>
              <Autocomplete
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                freeSolo
                size="small"
                fullWidth
                sx={{ mt: "0.5rem" }}
                options={diagnosis.provisionalDiagnosisSugg}
                getOptionLabel={(option) => (typeof option === "string" ? option : option)}
                value={diagnosis.provisionalDiagnosis}
                onChange={(event, newValue) => {
                  setDiagnosis((prev) => ({ ...prev, provisionalDiagnosis: newValue }))
                }}
                onInputChange={(e, newValue) => {
                  setDiagnosis((prev) => ({ ...prev, provisionalDiagnosis: newValue }))
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    multiline
                    label={"Provisional Diagnosis"}
                    placeholder={"Provisional Diagnosis (Max 250 Characters)"}
                    inputProps={{
                      ...params.inputProps, emed_id: 'dia_prov',
                      maxLength: 250,
                      emed_tid: 'prov_diagnosis_dropDown_testID'
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearch(value)
                    }}
                  />
                )}
              />
            </Box>
          </AccordionDetails>
        </Accordion>
        {diagnosis.PreviousDiagnosisPopup ?
          <PreviousDiagnosis
            key={"diagnosis"}
            title={"Diagnosis"}
            title2={"Provisional Diagnosis"}
            dateList={diagnosis.dateList}
            previousData={diagnosis.previousData || []}
            isIcdCode={true}
            is_loading = {diagnosis.is_previous_loading}
            onDateChange={(date) => { getPreviousDiagnosis(date) }}
            closePopup={closePreviousPopup}
            onCopyDiagnosis={(data) => { handleDiagnosisCopy("both", data) }}
            onCopyIcdCode={(data) => { handleDiagnosisCopy("IcdCode", data) }}
            onCopyDiagnosisTxt={(data) => { handleDiagnosisCopy("diagnosis", data) }}
          />
          : null}
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaDiagnosis